import { createFileRoute } from '@tanstack/react-router';

import { Link as TWLink } from 'web2/app/components/link';
import InlineSubscribeToSignUp from 'web2/app/components/inline-subscribe-to-sign-up';
import { preloadImageByKey } from '../../../lib/utils';
import { useAutoSetTheme } from 'shared/misc/providers/ThemeContext';
import { ProfileThemeType } from 'shared/__generated__/graphql';

export const Route = createFileRoute('/welcome/')({
  component: LandingPage,
  // ssr: false,
  head: () => ({
    meta: [
      {
        title: 'Perfectly Imperfect',
        description: "A taste of someone's taste.",
        openGraph: {
          images: [
            'https://files.pi.fyi/cdn-cgi/image/quality=50,format=auto/app-info-screenshot.png',
          ],
        },
      },
    ],
  }),
  loader: async () => {
    try {
      preloadImageByKey('star-background.png');
      preloadImageByKey('app-info-screenshot.png');
      preloadImageByKey('pi-goated-tweet.png');
    } catch (error) {
      console.error(error);
    }
  },
});

function LandingPage() {
  useAutoSetTheme(ProfileThemeType.PiClassic);

  return (
    <>
      <div
        className="flex flex-col h-full w-full items-center justify-center"
        style={{
          backgroundImage: 'url(https://files.pi.fyi/star-background.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="mt-6 md:mt-12 m-6 md:m-12 w-full lg:w-[800px]">
          <div className="flex flex-col w-full p-4 md:p-0">
            <div className="flex sm:justify-center">
              <img
                src="/static/logo-horizontal.svg"
                alt="Logo"
                className="self-center filter invert w-[200px] sm:w-[300px] sm:w-[400px] h-auto"
              />
            </div>

            <div className="flex flex-col gap-[6px]">
              <div className="typography-heading-xl sm:text-[default] sm:typography-heading-xl text-left sm:text-center text-brand-highlight my-[24px]">
                Do you miss the old internet?
              </div>
              <div className="typography-heading-sm sm:typography-heading-md sm:text-center text-brand-main mb-[12px] sm:px-[64px]">
                Before AI, soulless algo curation, psychopathic CEOs, and slop content took over?
              </div>
              <div className="typography-heading-sm sm:typography-heading-md sm:text-center text-brand-main sm:px-[64px] mt-[24px]">
                <span className="text-brand-highlight">...You came to the right place.</span>
              </div>
              <div className="py-[24px] sm:py-[36px]">
                <InlineSubscribeToSignUp
                  ctaText="share what you love on PI.FYI"
                  submitText="JOIN"
                  confirmationText="Welcome!"
                  // redirectTo="/sign-up/more"
                  withBorder={false}
                  withPadding={false}
                  withAutoFocus
                  withFinishSignUpModal
                  withInputDashedBorder
                  onlyInput
                />
                <div className="flex flex-col gap-3 mt-[18px]">
                  <div className="typography-action-sm text-brand-lightgrey text-left">
                    By clicking "JOIN" you agree to our{' '}
                    <TWLink
                      to="/terms"
                      className="text-brand-highlight hover:underline "
                      variant="stylized"
                    >
                      Terms
                    </TWLink>{' '}
                    and{' '}
                    <TWLink
                      to="/terms"
                      className="text-brand-highlight hover:underline "
                      variant="stylized"
                    >
                      Privacy
                    </TWLink>{' '}
                    conditions.
                  </div>
                  <div className="typography-action-sm text-brand-lightgrey text-left">
                    Download PI.FYI on the{' '}
                    <TWLink
                      to="https://apps.apple.com/us/app/pi-fyi-by-perfectly-imperfect/id6474037926"
                      className="text-brand-highlight hover:underline "
                      variant="stylized"
                    >
                      App Store
                    </TWLink>
                    .
                  </div>

                  {/* <div className="typography-body-sm text-brand-lightgrey text-left">
                  Already signed up?{' '}
                  <TWLink
                    to="/sign-in"
                    className="text-brand-highlight hover:underline "
                    variant="stylized"
                  >
                    Sign in
                  </TWLink>
                </div>
                <div className="typography-body-sm text-brand-lightgrey text-left">
                  Confused?{' '}
                  <TWLink
                    to="/what-is-this"
                    className="text-brand-highlight hover:underline"
                    variant="stylized"
                  >
                    Learn more
                  </TWLink>
                </div> */}
                </div>
              </div>
              <div className="border-t-[2px] border-b-[2px] border-dashed border-brand-main">
                <div className="typography-heading-sm sm:typography-heading-md text-brand-main mb-[16px] sm:px-[72px] pt-[24px]">
                  Perfectly Imperfect is{' '}
                  <span className="text-brand-highlight">the world's first social magazine</span>.
                </div>
                <div className="typography-heading-sm sm:typography-heading-md text-brand-main mb-[16px] sm:px-[72px]">
                  Read Cutting-edge editorial content from voices like{' '}
                  <span className="text-brand-highlight">
                    Charli XCX, Francis Ford Coppola, Pink pantheress, and the Rizzler
                  </span>
                  .
                </div>
                <div className="typography-heading-sm sm:typography-heading-md text-brand-main mb-[24px] sm:px-[72px]">
                  Discover music, films, books, and more, curated by{' '}
                  <span className="text-brand-highlight">our 60,000 users</span>.
                </div>
              </div>

              <div className="border-b-[2px] border-dashed border-brand-main">
                <div className="typography-heading-sm sm:typography-heading-md text-brand-main mb-[16px] sm:px-[72px] pt-[24px]">
                  "Perfectly Imperfect gazes back nostalgically to an era when corporate algorithms
                  didn’t control cultural discovery, and websites like The Strategist hadn’t
                  streamlined product recommendations."
                  <span className="text-brand-highlight"> - NYTimes</span>.
                </div>
                <div className="typography-heading-sm sm:typography-heading-md text-brand-main mb-[16px] sm:px-[72px]">
                  "I have read Perfectly Imperfect for many years and have benefited greatly from
                  this generous source of inspo."
                  <span className="text-brand-highlight"> - Lorde</span>.
                </div>
                <div className="typography-heading-sm sm:typography-heading-md text-brand-main mb-[16px] sm:px-[72px]">
                  "Perfectly Imperfect invites a wide berth of New York artists, writers,
                  intellectuals, and scenesters to spiral on bits of personal ephemera, consciously
                  rejecting the endless algorithmic scroll."
                  <span className="text-brand-highlight"> - Interview Magazine</span>.
                </div>
                <div className="typography-heading-sm sm:typography-heading-md text-brand-main mb-[16px] sm:px-[72px]">
                  "literally the only lifestyle recommendations u will ever need .. the best and
                  only way to break out of the chokehold of algorithmically generated content
                  recommendations and find some NEW SHIT!"
                  <span className="text-brand-highlight"> - Rayne Fisher Quann</span>.
                </div>
                <div className="typography-heading-sm sm:typography-heading-md text-brand-main mb-[16px] sm:px-[72px]">
                  "This is one of the only interviews he's enjoyed doing."
                  <span className="text-brand-highlight"> - [Redacted]'s publicist</span>.
                </div>
                <div className="typography-heading-sm sm:typography-heading-md text-brand-main mb-[16px] sm:px-[72px]">
                  "By showcasing the aesthetics, technologies, and even humor bubbling around
                  various contemporary scenes, the newsletter is less about directing you on how to
                  kit out your own life with the “right” goods, and more about cataloging the
                  various flotsam of our time."
                  <span className="text-brand-highlight"> - Vanity Fair</span>.
                </div>
                <div className="typography-heading-sm sm:typography-heading-md text-brand-main mb-[16px] sm:px-[72px]">
                  "PI.FYI IS HARM REDUCTION FOR MY INTERNET ADDICTION."
                  <span className="text-brand-highlight"> - A PI.FYI user</span>.
                </div>
              </div>
              {/* <div className="typography-heading-xl sm:text-[default] sm:typography-heading-xl text-left sm:text-center text-brand-highlight mb-[12px] hidden sm:flex">
                A<br />
                Taste
                <br />
                of
                <br />
                Taste
              </div>

              <div className="typography-action-sm sm:typography-heading-sm sm:text-center text-brand-main mb-[12px] mt-[24px] sm:mt-[12px] sm:px-[64px]">
                Join the <span className="text-brand-highlight">130,000+ people</span> on Perfectly
                Imperfect.
              </div> */}
              <div className="flex sm:justify-center w-full my-[24px]">
                <a
                  href="https://apps.apple.com/us/app/pi-fyi-by-perfectly-imperfect/id6474037926"
                  target="_blank"
                >
                  <img
                    src="https://files.pi.fyi/App_Store_Badge.png"
                    alt="star-blue"
                    width={500}
                    height={160}
                    className="max-w-[150px] sm:max-w-[200px] h-auto"
                  />
                </a>
              </div>

              <img
                src="https://files.pi.fyi/app-info-screenshot.png"
                width={400}
                height={60}
                alt="Logo"
                className="w-full h-auto mt-[24px]"
              />
              <img
                src="https://files.pi.fyi/lick.jpg"
                width={400}
                height={60}
                alt="Logo"
                className="w-full h-auto mt-[12px]"
              />
            </div>
            <div className="flex flex-col gap-1.5 border-[1px] border-dashed border-brand-main p-[12px] md:p-[24px] mt-[6px] hidden">
              <div className="typography-heading-md sm:typography-heading-lg leading-[150%] text-left md:text-center text-brand-title-background mb-[6px]">
                A Cult-favorite Newsletter
              </div>
              <div className="typography-action-sm text-[14px] sm:text-[18px] leading-[150%] text-brand-main">
                Interviews ft recommendations from Charli XCX, Lorde, Francis Ford Coppola, Ayo
                Edebiri, The Rizzler, Olivia Rodrigo, Michael Imperioli, Emma Chamberlain, Clairo,
                Ice Spice, Molly Ringwald, Weyes Blood, Jeremy O. Harris, Conner O'Malley,
                PinkPantheress, Rayne Fisher Quann, Julian Casablancas, Alexa Chung, Mac Demarco,
                Moses Sumney, Omar Apollo, Suki Waterhouse, Nardwuar, The Dare, and hundreds more in{' '}
                <TWLink
                  to="/read"
                  className="typography-action-sm text-[14px] sm:text-[18px] leading-[150%] text-brand-main"
                  variant="stylizedNoDefaultBorder"
                >
                  the Perfectly Imperfect Archive.
                </TWLink>
              </div>
              <div className="typography-action-sm text-[14px] sm:text-[18px] leading-[150%] text-brand-main mb-[12px]">
                The history and impact of Perfectly Imperfect is well-documented by The New York
                Times, NYMag, Vanity Fair, Interview Mag, Flaunt, Office, The Verge, and NPR.
              </div>
              <InlineSubscribeToSignUp
                ctaText="share what you love on PI.FYI"
                submitText="Subscribe"
                confirmationText="Welcome!"
                redirectTo="/read"
                withBorder={false}
                withPadding={false}
                withAutoFocus
                withFinishSignUpModal
                withInputDashedBorder
                onlyInput
              />
            </div>
            <div className="flex flex-col gap-1.5 border-[1px] border-dashed border-brand-main p-[12px] md:p-[24px] hidden">
              <div className="typography-heading-md sm:typography-heading-lg text-left md:text-center text-brand-title-background leading-[150%] mb-[6px]">
                An app for your taste
              </div>
              <div className="typography-action-sm text-[14px] sm:text-[18px] leading-[150%] text-brand-main">
                All the best parts of MySpace, Letterboxd, Reddit, Twitter, Tumblr, and Pinterest,
                combined into the perfect site.
              </div>
              <div className="typography-action-sm text-[14px] sm:text-[18px] leading-[150%] text-brand-main mb-[12px]">
                You can...discover new things from real people, share your best recommendations,
                theme your profile, log what brings you joy, connect over your interests, build
                custom lists, go to events, and much more.
              </div>
              <img
                src="https://files.pi.fyi/app-info-screenshot.png"
                width={400}
                height={60}
                alt="Logo"
                className="w-full h-auto"
              />
              <div className="flex justify-center w-full mt-12 mb-4">
                <a
                  href="https://apps.apple.com/us/app/pi-fyi-by-perfectly-imperfect/id6474037926"
                  target="_blank"
                >
                  <img
                    src="https://files.pi.fyi/App_Store_Badge.png"
                    alt="star-blue"
                    width={500}
                    height={160}
                    style={{
                      maxWidth: '200px',
                    }}
                  />
                </a>
              </div>
            </div>

            {/* <Text textStyle="brand.headingMd" color="brand.highlight" textAlign="center">
              Thousands of people are sharing what they love on PI.FYI.
            </Text>
            <Text textStyle="brand.headingMd" color="brand.highlight" textAlign="center">
              Why aren't you?
            </Text> */}
          </div>
        </div>
      </div>
    </>
  );
}
